import React from 'react'

const SearchIconBold = () => (
    <svg 
        className="search-svg"
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 22.37 22.37"
    >
        <g>
            <path 
                d="M22.37,20.96l-6.11-6.11c2.88-3.58,2.66-8.85-.67-12.18C12.04-.89,6.24-.89,2.68,2.67.95,4.4,0,6.69,0,9.13s.95,4.74,2.68,6.46c1.73,1.73,4.02,2.68,6.46,2.68,2.1,0,4.1-.71,5.71-2.01l6.11,6.11,1.41-1.41ZM4.09,14.18c-1.35-1.35-2.09-3.14-2.09-5.05s.74-3.7,2.09-5.05c1.39-1.39,3.22-2.09,5.05-2.09s3.66.7,5.05,2.09c2.78,2.78,2.78,7.31,0,10.1-1.35,1.35-3.14,2.09-5.05,2.09s-3.7-.74-5.05-2.09Z" 
            />
        </g>
    </svg>
)

export default SearchIconBold